import {Link, To} from 'react-router-dom'

import './Back.scss'
import {IconButton, ArrowIcon} from 'common/components'

interface BackProps {
  to: To
  state?: {
    [propName:string]: any;
  }
}

export default function Back({to, state}: BackProps) {
  return (
    <Link tabIndex={-1} className="Back" to={to} state={state}>
      <IconButton icon={<ArrowIcon className="Back-Icon" />} />
    </Link>
  )
}
